import { Address } from "@redotech/account-common/address";
import { WeightUnit } from "@redotech/crdb-enums/product/weight-unit";
import { PurchaseLabelType } from "@redotech/merchant-sdk/rpc/schema/purchase-label";
import { addressAutocompleteForm } from "@redotech/redo-web/address-autocomplete-form";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { AddressOption, SelectedShipping } from "./create-label-modal-types";

const LabelWeightFormDef = groupInput({
  weight: input<number>(),
  unit: input<WeightUnit>(),
});

const CreateLabelFormDef = groupInput({
  labelWeight: LabelWeightFormDef,
  selectedShipping: input<SelectedShipping | undefined>(),
  labelType: input<PurchaseLabelType>(),
  customShipFromAddressForm: addressAutocompleteForm,
  customShipToAddressForm: addressAutocompleteForm,
  shopperFinalAddress: input<Address | undefined>(),
  shopperSelectedAddress: input<AddressOption | undefined>(),
  merchantAddress: input<Address | undefined>(),
  merchantSelectedAddress: input<AddressOption | undefined>(),
  customShipFromAddress: input<Address | undefined>(),
  customShipToAddress: input<Address | undefined>(),
  emailLabelToShopper: input<boolean>(),
  shopperEmail: input<string>(),
});

export type CreateLabelForm = InputSchema.Input<typeof CreateLabelFormDef>;
export type CreateLabelValue = InputSchema.Value<typeof CreateLabelFormDef>;

export type LabelWeightForm = InputSchema.Input<typeof LabelWeightFormDef>;
export type LabelWeightValue = InputSchema.Value<typeof LabelWeightFormDef>;

export { CreateLabelFormDef, LabelWeightFormDef };
